import styled, { css } from "styled-components";
import OutlinedCard from "ui/common/components/surface/OutlinedCard/OutlinedCard";

export const AreaChartCardRoot = styled(OutlinedCard)(
    ({ theme }) => css`
        padding: ${theme.spacing["5"]};
        display: flex;
        flex-direction: column;
        row-gap: ${theme.spacing["4"]};
        .simple-area-chart {
            width: 100%;
        }
    `,
);
